import {useQuery} from '@tanstack/react-query'
import {useBazaarvoiceAPI} from '../context'
import {useEffect, useMemo} from 'react'
import useOcapiSite from '../../hooks/useOcapiSite'
import {getBVReviewProductIds} from '../../utils/product-utils'
import useEffectEvent from '../../hooks/use-effect-event'

/**
 * @param {object} product
 * @returns {{data: {AverageOverallRating: number, TotalReviewCount: number, OverallRatingRange: number}|null, error: null|Error, loading: boolean}}
 */
const useProductRating = (product) => {
    const {bvEnabled} = useOcapiSite()
    const {getProductRating} = useBazaarvoiceAPI()

    const pid = useMemo(() => getBVReviewProductIds(product), [product])
    const {
        data,
        error,
        isInitialLoading: loading
    } = useQuery({
        queryKey: ['product-rating', pid],
        queryFn: ({signal}) => getProductRating(pid, {signal}),
        enabled: Boolean(pid && bvEnabled),
        meta: {displayName: 'useProductRating'}
    })

    const onError = useEffectEvent((error) => {
        console.error('Error fetching product rating for', pid, error)
    })
    useEffect(() => {
        if (error) {
            onError(error)
        }
    }, [error, onError])

    return {
        data: data ?? null,
        error,
        loading
    }
}

export default useProductRating
